import React, { useState } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Question from './Question';
import Correct from './Correct';
import Incorrect from './Incorrect';
import Result from './Result';
import Certificate from './Certificate';

function Interface({ questions, onReset }) {
  const query = useQuery();
  const [scene, changeScene] = useState(query.get('test') == 'result' ? 3 : 0); //0:出題 1:間違え 2:正解 3:結果発表 4:表彰所
  const [number, setnumber] = useState(0); //問題番号
  const [correctNum, changeCorrentNum] = useState(query.get('test') == 'result' ? 10 : 0); //正解数
  const [name, setName] = useState();
  const [counter, setCounter] = useState();
  return (
    <>
      {(scene == 0 || scene > 4) && (
        //出題画面
        <Question
          number={number}
          question={questions[number]}
          handleCorrect={() => {
            //正解
            changeCorrentNum(correctNum + 1);
            changeScene(2);
          }}
          handleIncorrect={() => {
            changeScene(1);
          }}
        />
      )}
      {scene == 1 && (
        //間違え
        <Incorrect
          question={questions[number]}
          onClick={() => {
            setnumber(number + 1);
            if (number < questions.length - 1) {
              changeScene(0);
            } else {
              changeScene(3);
            }
          }}
          //
        />
      )}
      {scene == 2 && (
        //正解
        <Correct
          question={questions[number]}
          onClick={() => {
            setnumber(number + 1);
            if (number < questions.length - 1) {
              changeScene(0);
            } else {
              changeScene(3);
            }
          }}
          //
        />
      )}
      {scene == 3 && (
        //結果発表
        <Result
          correctNum={correctNum}
          length={questions.length}
          onClick={(name, counter) => {
            console.log('正解数:' + correctNum);
            console.log('問題数:' + questions.length);
            if (correctNum >= questions.length) {
              //全問正解
              changeScene(4);
              setName(name);
              setCounter(counter);
            } else {
              onReset();
              setnumber(0);
              changeCorrentNum(0);
              changeScene(0);
            }
          }}
          //
        />
      )}
      {scene == 4 && (
        //表彰所
        <Certificate
          name={name}
          counter={counter}
          onClick={() => {
            location.href = 'https://www.tanabotanical.com/#kentei';
          }}
          //
        />
      )}
      <button
        onTouchStart={() => {}}
        className="topBtn"
        onClick={() => {
          location.href = 'https://www.tanabotanical.com/#kentei';
        }}
      >
        <img src={'assets/img/btn-top.png'} alt="TOPにもどる" />
      </button>
    </>
  );
}

export default Interface;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
